export default {
	"exchange.inTheProduct": "in the product",
	"exchange.HasBeenActivatedInOrderToAvoidMissingTheExperienceTimePleaseLogInToTheCallMiniProgramOrAppAsSoonAsPossibleToExperience": "Has been activated, in order to avoid missing the experience time, please log in to the [Call] Mini Program or App as soon as possible to experience.",
	"exchange.ViewOrderDetails": "View order details",
	"exchange.LongPressToIdentifyTheQRCode": "Long press to identify the QR code",
	"exchange.EnterTheCallMiniProgram": "Enter the Call Mini Program"
}